<template>
  <div class="bg-secondary min-h-screen">
    <div class="pt-32 pb-20 lg:px-48 md:px-12 px-6 max-w-4xl mx-auto">
      <h1 class="font-pt-serif text-4xl font-bold mb-8">Політика конфіденційності</h1>
      <p class="font-montserrat text-sm text-gray-400 mb-10">Останнє оновлення: 2026-08-19</p>

      <div class="prose-policy">

        <p>Ця Політика конфіденційності описує, як <strong>AWR360 / Bible School (Hope365)</strong> («ми», «нас») збирає, використовує та захищає персональні дані користувачів сайту <strong>osnovy.bibleawr.com</strong>.</p>

        <h2>1. Які дані ми збираємо</h2>
        <p>При реєстрації на курс ми збираємо:</p>
        <ul>
          <li>Ім'я та прізвище</li>
          <li>Номер телефону</li>
          <li>Тип месенджера (Telegram або WhatsApp)</li>
        </ul>
        <p>Ми <strong>не</strong> збираємо платіжні дані, дані кредитних карток або конфіденційну медичну інформацію.</p>

        <h2>2. Як ми використовуємо ваші дані</h2>
        <p>Зібрані дані використовуються виключно для:</p>
        <ul>
          <li>Реєстрації вас як учасника курсу «Основи Віри»</li>
          <li>Надсилання уроків курсу через Telegram-бот або WhatsApp</li>
          <li>Відповідей на ваші запитання по темі курсу</li>
          <li>Надсилання молитовних відповідей на прохання</li>
        </ul>
        <p>Ми не передаємо ваші дані третім сторонам, не продаємо і не використовуємо для реклами.</p>

        <h2>3. Передача даних</h2>
        <p>Ваші дані обробляються на серверах <strong>bibleawr.com</strong> (платформа Bible School). Передача відбувається через захищене HTTPS-з'єднання. Дані зберігаються в базі даних на захищених серверах у Євросоюзі.</p>

        <h2>4. Строки зберігання</h2>
        <p>Ваші дані зберігаються протягом усього часу вашої участі у курсі та 12 місяців після його завершення. За вашим запитом дані можуть бути видалені раніше.</p>

        <h2>5. Ваші права</h2>
        <p>Ви маєте право:</p>
        <ul>
          <li>Запросити доступ до ваших персональних даних</li>
          <li>Виправити неточні дані</li>
          <li>Вимагати видалення ваших даних</li>
          <li>Відкликати згоду на обробку</li>
        </ul>
        <p>Для реалізації прав надішліть запит на <a href="mailto:hope365ua@gmail.com">hope365ua@gmail.com</a>.</p>

        <h2>6. Cookies</h2>
        <p>Сайт використовує мінімальний набір технічних cookies, необхідних для роботи сайту. Аналітичні cookies використовуються тільки при наявності GTM/GA і в анонімному режимі.</p>

        <h2>7. Контакти</h2>
        <p>З питань конфіденційності звертайтесь:</p>
        <ul>
          <li>Email: <a href="mailto:hope365ua@gmail.com">hope365ua@gmail.com</a></li>
          <li>Telegram: <a href="https://t.me/hope365ua_bot" target="_blank">@hope365ua_bot</a></li>
        </ul>

      </div>

      <div class="mt-12 pt-8 border-t border-gray-200">
        <NuxtLink :to="localePath('/')" class="font-montserrat text-sm growing-underline">
          ← На головну
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()
useHead({ title: 'Політика конфіденційності — Основи Віри' })
</script>

<style scoped>
.prose-policy :deep(h2) {
  font-family: 'PT Serif', serif;
  font-size: 1.5rem;
  font-weight: 700;
  margin-top: 2.5rem;
  margin-bottom: 1rem;
}
.prose-policy :deep(p) {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  line-height: 1.75;
  color: #374151;
  margin-bottom: 1rem;
}
.prose-policy :deep(ul) {
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  line-height: 1.75;
  color: #374151;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
  list-style: disc;
}
.prose-policy :deep(a) {
  text-decoration: underline;
  color: inherit;
}
.prose-policy :deep(strong) {
  font-weight: 600;
}
</style>
